import { render, staticRenderFns } from "./SalersResumeTable.vue?vue&type=template&id=6585588f&"
import script from "./SalersResumeTable.vue?vue&type=script&lang=js&"
export * from "./SalersResumeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports